import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AccordionCard } from 'src/components/AccordionCard';
import { DoubleColumnContainer } from 'src/components/DoubleColumnContainer';
import { PageTitle } from 'src/features/visits/shared/components/PageTitle';
import { AssessmentTitle } from '../../../../../components/AssessmentTitle';
import { useGetAppointmentAccessibility } from '../../hooks/useGetAppointmentAccessibility';
import { useChartData } from '../../stores/appointment/appointment.store';
import { useAppFlags } from '../../stores/contexts/useAppFlags';
import { AiPotentialDiagnosesCard } from '../AiPotentialDiagnosesCard';
import { BillingCodesContainer } from './BillingCodesContainer';
import { DiagnosesContainer } from './DiagnosesContainer';
import { EMCodeField } from './EMCodeField';
import { MedicalDecisionContainer } from './MedicalDecisionContainer';

export const AssessmentCard: FC = () => {
  const { t } = useTranslation();
  const { chartData } = useChartData();

  const { isAppointmentReadOnly: isReadOnly } = useGetAppointmentAccessibility();
  const emCode = chartData?.emCode;
  const { isInPerson } = useAppFlags();

  return (
    <Stack spacing={1} sx={{ width: '100%' }}>
      <PageTitle label={t('telemed.assessment.title')} showIntakeNotesButton={false} />
      <AiPotentialDiagnosesCard />
      <AccordionCard label={isInPerson ? undefined : t('telemed.assessment.title')}>
        <DoubleColumnContainer
          divider
          leftColumnSize={5}
          rightColumnSize={7}
          leftColumn={
            <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <DiagnosesContainer />
              {isInPerson && <MedicalDecisionContainer />}
            </Box>
          }
          rightColumn={
            <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
              {!isInPerson && <MedicalDecisionContainer />}
              {isInPerson ? (
                <BillingCodesContainer />
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <AssessmentTitle>{t('telemed.assessment.billing.emCode')}</AssessmentTitle>
                  {isReadOnly ? (
                    emCode ? (
                      <Typography>{emCode.display}</Typography>
                    ) : (
                      <Typography color="secondary.light">{t('telemed.assessment.diagnoses.notProvided')}</Typography>
                    )
                  ) : (
                    <EMCodeField />
                  )}
                </Box>
              )}
            </Box>
          }
        />
      </AccordionCard>
    </Stack>
  );
};
